import INC_BASE_API from 'apis/incentivio-api';
import { getResponseErrorMessage } from 'apis/incentivio-api.util';
import { useURLSearchParams } from 'hooks/useURLSearchParams';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const useVerifySmsRequest = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const code = useURLSearchParams().get('code');

  useEffect(() => {
    const verifySmsRequest = async () => {
      setLoading(true);
      try {
        await INC_BASE_API.get(`verifysms?code=${code}`);
      } catch (error) {
        toast.error(getResponseErrorMessage(error));
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    if (!!code) verifySmsRequest();
    else setError(true);
  }, [code, setLoading]);

  return { loading, error };
};
